import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { L as inputRadioInvalid, M as inputRadioCheckedFocused, N as inputRadioChecked, O as inputRadioFocused, P as inputRadio, l as label } from './parts.js';
import { d as defineCustomElement$1 } from './form-control-help-text2.js';

const RadioInput = /*@__PURE__*/ proxyCustomElement(class RadioInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.isFocused = false;
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, this.value);
            this.formControlInput.emit({ name, value: this.value });
        };
    }
    get part() {
        if (this.errorText) {
            return inputRadioInvalid;
        }
        if (this.isFocused && this.checked) {
            return inputRadioCheckedFocused;
        }
        if (this.checked) {
            return inputRadioChecked;
        }
        if (this.isFocused) {
            return inputRadioFocused;
        }
        return inputRadio;
    }
    render() {
        return (h(Host, { key: 'f64818218ad7948cbf10584441a9fe1fc168a81d', class: 'form-group d-flex flex-column' }, h("div", { key: 'e16491d161f65e1d3b2ffa00e94d77ddc68745a8', class: "form-check" }, h("input", { key: '74ef42c720891c97a9ca22828999a93bebea6733', ref: el => (this.radioElement = el), type: "radio", id: `${this.name}-${this.value}`, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onChange: this.handleFormControlInput, part: this.part, class: this.errorText ? 'form-check-input is-invalid' : 'form-check-input', disabled: this.disabled, value: this.value, checked: this.checked }), h("label", { key: '2d7a743ea02759dd39257de8c9abd89ed1b67a71', class: "form-check-label", htmlFor: `${this.name}-${this.value}`, part: label }, this.label)), h("form-control-help-text", { key: 'b9326e463116d081f65dee449c7c437098d78533', helpText: this.helpText, name: this.name }), h("form-control-error-text", { key: '4bc1eb8e78083d6dd81ee2b6cd523a29fb13bfa0', errorText: this.errorText, name: this.name })));
    }
}, [0, "form-control-radio", {
        "label": [1],
        "name": [8],
        "value": [1],
        "helpText": [1, "help-text"],
        "inputHandler": [16, "input-handler"],
        "disabled": [4],
        "errorText": [1, "error-text"],
        "checked": [4],
        "isFocused": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-radio", "form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-radio":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RadioInput);
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { RadioInput as R, defineCustomElement as d };
